<template>
  <div class="headerMenu">
      <div class="view-container">
        <div class="h-row">
        </div>
        <div class="h-row">
            <div class="h-col">
                <div class="h-col-l">项目名称</div>
                <div class="h-col-r">{{project.projectname | toolongOmitted}}</div>
            </div>
            <div class="h-col">
                <div class="h-col-l">项目编号</div>
                <div class="h-col-r">{{project.projectcode}}</div>
            </div>
        </div>
        <div class="h-row">
            <div class="h-col">
                <div class="h-col-l">采购人</div>
                <div class="h-col-r">{{project.pcomfullname | toolongOmitted}}</div>
            </div>
            <div class="h-col" v-if="project.projectysflg"> 
                <div class="h-col-l">项目预算</div>
                <div class="h-col-r">
                  ￥{{project.projectlimitamt | qfwVal}}元 &nbsp;&nbsp;&nbsp; {{project.projecthsflg?'含税':'不含税'}}
                </div>
            </div>
        </div>
        <div class="h-row">
            <div class="h-col">
                  <div class="h-col-l">比选文件</div>
                  <div class="h-col-r">
                    <div v-if="project.appendList_zb && project.appendList_zb.length" class="view-filelist">
                      <div v-for="(item,index) in project.appendList_zb" :key="index" class="view-fileitem">
                        <div class="view-filename" @click="downFile(item.appendurl, item.appendid)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename | toolongOmitted}}</a>
                        </div>
                      </div>
                    </div>
                    <div v-else class="view-value">无</div>
                  </div>
              </div>
              <div class="h-col"> 
                  <div class="h-col-l">评审方法</div>
                  <div class="h-col-r">
                    <div class="view-con">{{project.prsflgdesc}}——{{project.projectdoneflgdesc}}<span v-if="project.prsflg !== '2' && project.prsflg !== '6'">——{{project.projectpricecomputebasisdesc}}</span></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
  import menuMixin from '@/components/mixin/menu'
  import request from '@/utils/request'
  import utils from '../../../assets/js/utils'
  import common from '@/mixin/common'
  import amount from '../../../views/common/amount'
  export default {
    name: 'vgheader',
    mixins: [
      menuMixin,common
    ],
    data(){
      return{
        project:{}
      }
    },
    created () {
    },
    mounted(){
      this.getModel()
    },
    filters: {
      qfwVal (value) {
        if (!!value && +value > 0) {
          return utils.comdify(value)
        } else {
          return value
        }
      },
      toolongOmitted(val){
        if(val){
          if(val.length > 30){
            return val.substring(0,15) + '...' 
          }
          else{
            return val
          }
        }
        return val
      }
    },
    components: {amount},
    watch: {
    },
    computed:{
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
      },
    }
  }
</script>
<style lang="scss" scoped>
.view-container{
    width: 800px !important;
    font-size: 14px;
    color: #606266;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
}
.h-row{
  display:flex;
}
.h-col{
  display:flex;
  width: 440px;
}
.h-col-l{
  width:70px;
  margin-right: 10px;
  text-align: right;
}
.h-col-r{
  width:400px;
  color:#999999;;
}
.view-filelist {
  //width: 50%;
  .view-fileitem {
    display: flex;
    text-align: left;
    //padding-left: 10px;
    .view-filename {
      color: #409EFF;
      cursor: pointer;
      flex: 1;
    }
    .view-filebtn {
      padding: 0 30px;
      span {
        color: #2f74ff;
        cursor: pointer;
      }
    }
  }
}
</style>
